import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Subject, Subscription, debounceTime, merge, startWith, switchMap } from 'rxjs';
import { FeedbackService } from '@app/core/services';
import { VendorService } from '@app/modules/fund-management/accounts-payable/vendors/services/vendor.service';
import { VendorModel, VendorSearch } from '@app/modules/fund-management/reports/models/vendor-payments';
import { ModalComponent } from '../modal/modal.component';

@Component({
    selector: 'vendor-search',
    templateUrl: './vendor-search.component.html',
    standalone: true,
    imports: [
        ModalComponent,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatIconModule,
        MatSelectModule,
        MatOptionModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
    ],
})
export class VendorSearchComponent implements AfterViewInit, OnDestroy {
	private searchSubject = new Subject<string>();
	private vendorSubject = new Subject<number>();
	private subscription: Subscription;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;
	displayedColumns: string[] = ['ShortName', 'VendorName', 'ParentVendor'];
	dataSource = new MatTableDataSource<VendorModel>();
	vendorPaging: VendorSearch = {
		searchText: '',
		statusId: 0,
		pageSize: 12,
		startIndex: 0,
		orderBy: 'ShortName',
		orderByDescending: false,
	};
	searchInput = '';
	vendorStatusValue = 0;
	dataSourceLength: number;

	constructor(
		private readonly vendorService: VendorService,
		private readonly feedbackService: FeedbackService,
		public dialogRef: MatDialogRef<VendorSearchComponent>
	) {}

	ngAfterViewInit(): void {
		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		this.subscription = merge(this.sort.sortChange, this.paginator.page, this.vendorSubject, this.searchSubject.pipe(debounceTime(300)))
			.pipe(
				startWith({}),
				switchMap(() => {
					this.vendorPaging = {
						...this.vendorPaging,
						startIndex: this.paginator.pageIndex > 0 ? this.vendorPaging.pageSize * this.paginator.pageIndex : 0,
						searchText: this.searchInput,
						statusId: this.vendorStatusValue,
						orderBy: this.sort.active,
						orderByDescending: this.sort.direction === 'desc',
					};
					return this.vendorService.getVendorsByPage(this.vendorPaging);
				})
			)
			.subscribe({
				next: (response) => {
					this.dataSource.data = response.vendors;
					this.dataSourceLength = response.totalNumberOfVendors;
				},
				error: (error: HttpErrorResponse) => {
					const errorMessage = error.error?.ExceptionMessage || error.error?.Message || '';
					this.feedbackService.error(`There was a problem loading Vendor List: ${errorMessage}`);
				},
			});
	}

	vendorSearch(): void {
		this.searchSubject.next(this.searchInput);
	}

	vendorStatus(): void {
		this.vendorSubject.next(this.vendorStatusValue);
	}

	clickRow(row: VendorModel): void {
		this.dialogRef.close(row);
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
